import React, { Fragment, useState, useEffect } from "react";
import AntTable from "../../common/Table"; 
import { compose, graphql } from 'react-apollo';
import { removeRoomM } from "../../../graphql/mutation/room";
import columns from "../../../const/columns/rooms";
import { openNotificationWithIcon } from "../../common/Notification";
import routes from "../../../const/routes";
import RefreshButton from "../../common/RefreshButton";
import { Spin } from "antd";

function Rooms({props, removeRoom}){
    let [ rooms, setRoms ] = useState([]);

    useEffect(() => {
        
        if(props.rooms.data && props.rooms.data.data && props.rooms.data.data.rooms && props.rooms.data.data.message === "Rooms found."){

            let roomsCopy = props.rooms.data.data.rooms.slice();

            /*roomsCopy.map(room => {
                props.vouchers.data.data.branchs.map(branch => {
                    if(room.branch && room.branch === branch._id){
                        room.filial = branch.name;
                    }
                    return null
                })
                return null
            })*/


            setRoms(roomsCopy)
        }
    }, [props.rooms]);
 
    async function deleteF(id){
        let body = {
            _id: id,
            removeRoom 
        };
    
        await props.REMOVE_ROOM(body);

        setTimeout(() => {getRooms()},100)
        openNotificationWithIcon('success', "Sucesso", "Sala deletada com sucesso", "", 7);
    }

    function update(id){
        localStorage.setItem('@Ossel:Update', true);
        localStorage.setItem('@Ossel:UpdateID', id);
    }

    useEffect(() => {
        getRooms()
    }, []);

    function getRooms(){
        let body = {
            key: "YOU_SH@LL_P@SS",
            type: "all",
            filter: "",
        };

        props.GET_ROOMS(body)
    }
    
    return(
        <Fragment> 
            <RefreshButton clickAction={getRooms}/>
            <Spin spinning={props.rooms.loading}>
                <AntTable 
                    dataSource={rooms} 
                    columns={columns} 
                    new={routes.ROOMS_NEW} 
                    delete={deleteF} 
                    update={update}
                    btEdit={true}
                    hideBtnNew={false}
                />
            </Spin>
        </Fragment>
    )
}

export default compose(
    graphql( removeRoomM, { name: "removeRoom" } )
)(Rooms);


// WEBPACK FOOTER //
// ./src/components/general/roomsWrapper/Rooms.jsx